import styled from 'styled-components';

export const FeatureCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FeatureCard = styled.div`
  ${props => props.theme.media.md} {
    width: calc((100% / ${props => props.cols || 2}) - 30px);
    padding: 15px 25px;
  }
  transition: all 0.2s;
  margin: 15px;
  min-width: 320px;
  .inner {
    max-width: 350px;
    margin: 0 auto;
    display: flex;
    ${props => props.theme.media.md} {
      display: block;
    }
    .icon {
      width: 69px;
      height: 69px;
      margin: 0 25px 15px 0;
      display: flex;
      justify-content: center;
      ${props => props.theme.media.md} {
        justify-content: flex-start;
        margin-bottom: 15px;
        width: auto;
        height: auto;
      }
    }
    .text {
      flex-basis: 0;
      flex-grow: 1;
    }
  }
  h4 {
    font-size: 0.875rem;
    margin: 0 0 0.2em;
    text-transform: uppercase;
  }
  p {
    margin: 0;
    font-size: 0.9375rem;
    line-height: 1.5;
    font-weight: 400;
  }
`;
